import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "app/store";
import SideNavigation from "@amzn/awsui-components-react/polaris/side-navigation";
import Box from "@amzn/awsui-components-react/polaris/box";
import Button from "@amzn/awsui-components-react/polaris/button";
import Popover from "@amzn/awsui-components-react/polaris/popover";
import ApiIndicator from "components/api-indicator";
import { useGetAllTemplatesQuery } from "features/allTemplates";
import { useNavConfig, useOnFollowHandler } from "./hooks";
import { LINKS } from "utils/constants";

const LeftNavigation: React.FC = () => {
  const onFollowHandler = useOnFollowHandler();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { header, items, activeHref } = useNavConfig();
  const { alias } = useAppSelector((state) => state.auth.user);
  const { data, error, isLoading, isError } = useGetAllTemplatesQuery({
    userAlias: alias,
  });

  const isAdmin = data?.isAdmin ?? false;

  return (
    <>
      <SideNavigation
        header={header}
        items={items}
        activeHref={activeHref}
        onFollow={onFollowHandler}
        data-testid="navigation"
      />
      <Box margin={{ left: "l" }}>
        <ApiIndicator
          isLoading={isLoading}
          isError={isError}
          isAlertError={true}
          error={error}
        />
      </Box>
      <Box margin={{ left: "l", top: "s" }}>
        {!isLoading &&
          (isAdmin ? (
            <Button
              variant="primary"
              onClick={() => navigate("/template/create")}
            >
              {t("left_nav.create_template_button")}
            </Button>
          ) : (
            <Popover
              dismissButton={false}
              position="right"
              size="small"
              triggerType="custom"
              content={t("left_nav.admin_popover")}
            >
              <Button
                variant="primary"
                href={LINKS.NEW_TEMPLATE_TICKET_TEMPLATE}
              >
                {t("left_nav.create_template_button")}
              </Button>
            </Popover>
          ))}
      </Box>
    </>
  );
};

export default LeftNavigation;
